import React from "react";
import { Col, DatePicker, Form, Row, Select, Spin } from "antd";
import styled from "@emotion/styled";
import { ComponentTitle, ExportButton } from "../../custom-components";
import { TaskRow } from "../../zype/styled-components";
import useYoutubeAnalyticsHook from "../youtube/hooks/useYoutubeAnalyticsHook";

const { RangePicker } = DatePicker;

export const ExportCard = styled("div")`
  background: #fff;
  border-radius: 8px;
  min-height: 250px;
  width: 450px;
  max-height: calc(100vh - 185px);
  overflow-x: hidden;
  overflow-y: auto;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
`;

const YoutubeExport = () => {
  const { form, exportAnalytics } = useYoutubeAnalyticsHook();

  const optionsList = [
    { label: "Views", value: "views" },
    { label: "Watch Time (hrs)", value: "watch_time_hrs" },
    { label: "Avg View duration", value: "avg_view_duration" },
    { label: "Unique viewers", value: "unique_viewers" },
    { label: "New Viewers", value: "new_viewers" },
    { label: "Returning Viewers", value: "returning_viewers" },
    { label: "Subs Gained", value: "subs_gained" },
    { label: "Subs Lost", value: "subs_lost" },
    { label: "Likes", value: "likes" },
    { label: "Dislikes", value: "dislikes" },
    { label: "Shares", value: "shares" },
  ];

  return (
    <Spin spinning={false}>
      <Row justify="center">
        <Col>
          <ComponentTitle>Youtube Export</ComponentTitle>
        </Col>
      </Row>
      <TaskRow>
        <ExportCard>
          <Form form={form} requiredMark={false} layout="vertical">
            <Form.Item
              label="Metrics"
              name="options"
              rules={[{ required: true, message: "Please select at least one option" }]}
            >
              <Select
                mode="multiple"
                placeholder="Select options"
                allowClear
              >
                {optionsList.map(opt => (
                  <Select.Option key={opt.value} value={opt.value}>
                    {opt.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="Date Range"
              name="date_range"
              rules={[{ required: true, message: "Please select a date range" }]}
            >
              <RangePicker style={{ width: "100%" }} />
            </Form.Item>
          </Form>
          <div style={{ textAlign: "right" }}>
            <ExportButton type="primary" onClick={exportAnalytics} />
          </div>
        </ExportCard>
      </TaskRow>
    </Spin>
  );
};

export default YoutubeExport;